import * as moment from "moment";

import * as models from "./models";
import { ActionableTaskAction } from "./actions";
import * as actions from "./actionTypes";

export function actionableTasks(state: models.ActionableTasksListModel[] = [], action: ActionableTaskAction): models.ActionableTasksListModel[] {
    switch (action.type) {
        case actions.INSUFFICIENT_TASK_ACTIONED_SUCCESS:
            return [];
        case actions.LOAD_ACTIONABLE_TASKS_SUCCESS:
            return action.payload.map(c => ({ ...c, referralCreated: moment() }));
        default:
            return state;
    }
}

export function actionableTask(state: models.ActionableTaskDetailModel = null, action: ActionableTaskAction): models.ActionableTaskDetailModel {
    switch (action.type) {
        case actions.INSUFFICIENT_TASK_ACTIONED_SUCCESS:
            return null;
        case actions.LOAD_ACTIONABLE_TASKS_SUCCESS:
            return null;
        case actions.LOAD_ACTIONABLE_TASK_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
